export default "__VITE_ASSET__LsazX1Rd__"